/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index upload to autogenerate all the components and extensions
 * Used by "prepareUploads"
 */

import Upload from './upload/Upload'
export * from './upload/Upload'
export default Upload
